
import { OutlinedInput, InputLabel, Box} from "@mui/material";
import { withTheme } from "@emotion/react";


const TextInput = (props) => {

    const theme = props.theme

    return (
    <Box ml={{sm: props.ml ?? '0px'}} width= {{xs:'100%', md:props.boxWidth ?? 'auto'}} mt={{xs:'8px', md: props.mt ?? '0px'}} >
        <InputLabel sx={{...theme.typography.inputTitle, color:'#292727'}} htmlFor="text">{props.textLable}</InputLabel>
        <OutlinedInput
         sx={{
            marginTop:'8px',
            width:{xs:'inherit',md: props.inputWidth ?? 'auto'},
            '& .MuiOutlinedInput-notchedOutline':{
               borderColor: '#98A2B3',
               borderRadius:'8px',
               paddingLeft:'24px',

            },
            ...theme.typography.textArea,
            color:'#98A2B3'
         }}
        placeholder={props.placeholder}
        id="text"
         />
    </Box>
    )
}
export default withTheme(TextInput)